/* footer-2026.js — MS 2026-06-01
   Footer columns render <details open> (SSR desktop-correct, no FOUC, no-JS safe).
   Below 1024px, remove [open] so the native mobile accordion (click-to-toggle) is restored.
   Desktop >=1024: [open] stays -> UA does not apply closed-state content-visibility:hidden
   to the slot, so link lists render. (display:flex rule in CSS is now redundant-but-harmless.) */
(function () {
  var mq = window.matchMedia('(min-width: 1024px)');
  var nodes = document.querySelectorAll('.footer-2026__col--accordion');
  if (!nodes.length) return;
  function sync() {
    var collapse = !mq.matches;
    for (var i = 0; i < nodes.length; i++) {
      if (collapse) nodes[i].removeAttribute('open');
      else nodes[i].setAttribute('open', '');
    }
  }
  sync();
  mq.addEventListener('change', sync);
})();
